(() => {
  'use strict';
  const instances = new WeakMap();
  const text = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
  function init(root) {
    if (instances.has(root)) return;
    const form = root.querySelector('[data-product-form]');
    const json = root.querySelector('[data-hamilton-product]');
    const button = form?.querySelector('[data-add-to-cart]');
    if (!form || !json || !button) return;
    const product = JSON.parse(json.textContent);
    const optionNames = product.options.map(option => typeof option === 'string' ? option : option.name);
    const selects = optionNames.map(name => Array.from(form.querySelectorAll('select[name^="options["]')).find(select => select.name === `options[${name}]`));
    const sizeIndex = optionNames.findIndex(name => /^(talla|size)$/i.test(name));
    const sizeSelect = selects[sizeIndex];
    const initial = product.variants.find(variant => String(variant.id) === root.dataset.initialVariant);
    const state = { chosen: sizeIndex < 0 || !!initial, unavailable: null, busy: false, disposed: false };
    const sticky = root.querySelector('[data-pdp-sticky]');
    const stickyButton = root.querySelector('[data-pdp-sticky-button]');
    const status = root.querySelector('[data-pdp-size-status]');
    const stockContact = root.querySelector('[data-pdp-stock-contact]');
    const nativeLabel = button.querySelector('[data-add-to-cart-text]');
    const optionButtons = Array.from(root.querySelectorAll('[data-pdp-option]'));
    const sizeSystems = Array.from(root.querySelectorAll('[data-pdp-size-system]'));
    const equivalence = root.querySelector('[data-pdp-size-equivalence]');
    const cartSize = form.querySelector('[data-pdp-cart-size]');
    const chartElement = root.querySelector('.product-form__chip-wrapper[data-size-chart]');
    if (chartElement && sizeSystems.length) {
      const sizeMap = new Map(chartElement.dataset.sizeChart.split('|').map(pair => pair.split(':')));
      const sizeChips = optionButtons.filter(chip => Number(chip.dataset.pdpOption) - 1 === sizeIndex);
      const complete = sizeChips.length > 0 && sizeChips.every(chip => sizeMap.has(chip.dataset.pdpValue));
      sizeChips.forEach(chip => { if (complete) chip.dataset.pdpUsSize = sizeMap.get(chip.dataset.pdpValue); });
      sizeSystems.forEach(control => { control.disabled = !complete; });
      const controls = chartElement.parentElement.querySelector('.hamilton-size-system');
      if (controls) controls.hidden = !complete;
    }
    let sizeSystem = 'MX';
    const displaySize = (mx) => {
      const chip = optionButtons.find(el => Number(el.dataset.pdpOption) - 1 === sizeIndex && el.dataset.pdpValue === mx);
      return sizeSystem === 'US' && chip?.dataset.pdpUsSize ? `US ${chip.dataset.pdpUsSize} · MX ${mx}` : `MX ${mx}`;
    };
    const renderSizeSystem = () => {
      sizeSystems.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.pdpSizeSystem === sizeSystem)));
      optionButtons.forEach(chip => {
        if (Number(chip.dataset.pdpOption) - 1 !== sizeIndex || !chip.dataset.pdpUsSize) return;
        const number = sizeSystem === 'US' ? chip.dataset.pdpUsSize : chip.dataset.pdpValue;
        text(chip.querySelector('[data-pdp-size-label]'), number);
        chip.setAttribute('aria-label', `Talla ${sizeSystem} ${number}, ${sizeSystem === 'US' ? 'MX ' + chip.dataset.pdpValue : 'US ' + chip.dataset.pdpUsSize}`);
      });
    };
    const cleanups = [];
    const on = (target, type, handler, capture = false) => { target.addEventListener(type, handler, capture); cleanups.push(() => target.removeEventListener(type, handler, capture)); };
    const variant = () => product.variants.find(v => v.options.every((value, i) => !selects[i] || selects[i].value === value));
    const focusSize = () => {
      const first = sizeSelect?.closest('.product-form__option')?.querySelector('button') || sizeSelect;
      if (first) { first.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); first.focus({ preventScroll: true }); }
      text(status, 'Elige tu talla para continuar.');
    };
    function modalOpen() {
      if (document.body.classList.contains('scroll-lock')) return true;
      return Array.from(document.querySelectorAll('[role="dialog"],dialog,.lightbox,.drawer,.ks-modal')).some(el => {
        const style = getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth && !el.hidden && el.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && el.getBoundingClientRect().width > 0;
      });
    }
    function stickyVisibility() {
      if (!sticky || state.disposed) return;
      const passed = button.getBoundingClientRect().bottom < 0;
      const hidden = !matchMedia('(max-width:1023px)').matches || !passed || modalOpen();
      if (sticky.hidden !== hidden) sticky.hidden = hidden;
    }
    function sync() {
      if (state.disposed) return;
      const current = state.unavailable || variant();
      const needsSize = sizeIndex >= 0 && !state.chosen;
      const loading = button.classList.contains('bttn--loading');
      state.busy = loading;
      const available = !!current?.available && !state.unavailable;
      const label = loading ? 'Añadiendo…' : needsSize ? 'Selecciona tu talla' : available ? 'Añadir al carrito' : current ? 'Agotado' : 'No disponible';
      text(nativeLabel, label);
      button.disabled = !needsSize && !available;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-disabled', String(button.disabled));
      button.setAttribute('aria-busy', String(loading));
      if (stickyButton) { text(stickyButton, label); stickyButton.disabled = loading || button.disabled; }
      const priceNode = root.querySelector('[data-product-price]');
      const priceText = priceNode?.textContent.trim() || '';
      const storePrice = priceText.endsWith(root.dataset.currency) ? priceText : `${priceText} ${root.dataset.currency}`.trim();
      text(priceNode, storePrice);
      text(root.querySelector('[data-pdp-sticky-price]'), storePrice);
      text(root.querySelector('[data-pdp-cta-price]'), storePrice);
      const accessibleLabel = `${label}, ${storePrice}`;
      if (button.getAttribute('aria-label') !== accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
      text(root.querySelector('[data-pdp-sticky-size]'), sizeIndex < 0 ? product.title : needsSize ? 'Selecciona tu talla' : `Talla ${displaySize(state.unavailable ? state.unavailable.options[sizeIndex] : sizeSelect?.value || '—')}`);
      if (stockContact) stockContact.hidden = needsSize || available;
      optionButtons.forEach(chip => {
        const i = Number(chip.dataset.pdpOption) - 1;
        if (i === sizeIndex) {
          const matching = product.variants.filter(v => v.options[i] === chip.dataset.pdpValue && v.options.every((val, option) => option === i || !selects[option] || selects[option].value === val));
          chip.classList.toggle('disabled', !matching.some(v => v.available));
        }
        const selected = (i !== sizeIndex || state.chosen) && chip.dataset.pdpValue === (state.unavailable ? state.unavailable.options[i] : selects[i]?.value);
        chip.classList.toggle('selected', selected);
        chip.setAttribute('aria-pressed', String(selected));
        chip.setAttribute('aria-disabled', String(chip.classList.contains('disabled')));
      });
      const selectedSize = !needsSize && (state.unavailable ? state.unavailable.options[sizeIndex] : sizeSelect?.value);
      const selectedChip = optionButtons.find(chip => Number(chip.dataset.pdpOption) - 1 === sizeIndex && chip.dataset.pdpValue === selectedSize);
      text(equivalence, selectedChip?.dataset.pdpUsSize ? `MX ${selectedSize} equivale a US ${selectedChip.dataset.pdpUsSize}` : '');
      if (cartSize) {
        const confirmed = !needsSize && available && !!selectedChip?.dataset.pdpUsSize;
        cartSize.disabled = !confirmed;
        const value = confirmed ? `MX ${selectedSize} / US ${selectedChip.dataset.pdpUsSize}` : '';
        if (cartSize.value !== value) cartSize.value = value;
      }
      renderSizeSystem(); stickyVisibility();
    }
    on(form, 'change', event => {
      if (!selects.includes(event.target)) return;
      if (event.target === sizeSelect) state.chosen = true;
      state.unavailable = null;
      text(status, '');
      setTimeout(sync, 0);
    }, true);
    on(root, 'click', event => {
      const system = event.target.closest('[data-pdp-size-system]');
      if (system?.dataset.pdpSizeSystem) {
        event.preventDefault();
        sizeSystem = system.dataset.pdpSizeSystem === 'US' ? 'US' : 'MX';
        sync(); return;
      }
      const chip = event.target.closest('[data-pdp-option]');
      if (!chip) return;
      if (Number(chip.dataset.pdpOption) - 1 === sizeIndex) {
        state.chosen = true;
        if (chip.classList.contains('disabled')) {
          event.preventDefault(); event.stopImmediatePropagation();
          state.unavailable = product.variants.find(v => v.options[sizeIndex] === chip.dataset.pdpValue && v.options.every((val, i) => i === sizeIndex || !selects[i] || selects[i].value === val)) || null;
          text(status, `La talla ${displaySize(chip.dataset.pdpValue)} no está disponible. Consulta con nuestro equipo.`);
          sync(); return;
        }
      }
      state.unavailable = null;
      setTimeout(sync, 0);
    }, true);
    on(form, 'submit', event => {
      if (sizeIndex >= 0 && !state.chosen) { event.preventDefault(); event.stopImmediatePropagation(); focusSize(); return; }
      if (state.busy || state.unavailable || !variant()?.available) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      state.busy = true;
    }, true);
    if (stickyButton) on(stickyButton, 'click', () => {
      if (sizeIndex >= 0 && !state.chosen) focusSize();
      else if (!state.busy && !button.disabled) button.click();
    });
    const syncObserver = new MutationObserver(() => { if (!state.disposed) sync(); });
    syncObserver.observe(button, { attributes: true, attributeFilter: ['class'] });
    const price = root.querySelector('[data-product-price]');
    if (price) syncObserver.observe(price, { childList: true, characterData: true, subtree: true });
    let frame;
    const positionGuide = () => {
      const target = sizeSelect?.closest('.product-form__option')?.querySelector('.product-form__option-label-wrapper');
      const guide = root.querySelector('.ks-chart-container.sizing-chart-container');
      if (target && guide && guide.parentElement !== target) target.append(guide);
      const trigger = guide?.querySelector('.ks-chart-modal-link');
      if (trigger) {
        if (trigger.getAttribute('aria-label') !== 'Guía de tallas') trigger.setAttribute('aria-label', 'Guía de tallas');
        Array.from(trigger.querySelectorAll('span')).concat(trigger).forEach(el => Array.from(el.childNodes).filter(node => node.nodeType === 3 && /^ver guía de tallas$/i.test(node.textContent.trim())).forEach(node => { node.textContent = ' Guía de tallas'; }));
      }
    };
    const meta = root.querySelector('.product__meta');
    const card = root.querySelector('.product__meta-inner');
    const assistance = root.querySelector('.hamilton-assistance');
    const fitPurchase = () => {
      if (!meta || !card) return;
      const header = document.querySelector('.hamilton-header-compact .header') || document.querySelector('.header-container') || document.querySelector('.header');
      const offset = (header?.getBoundingClientRect().height || 72) + 24;
      // Tall content scrolls into view before sticking at its bottom edge.
      // Native sticky positioning stops the card at the gallery's grid boundary.
      const top = `${Math.min(offset, innerHeight - meta.getBoundingClientRect().height - 24)}px`;
      if (root.style.getPropertyValue('--hp-sticky-top') !== top) root.style.setProperty('--hp-sticky-top', top);
    };
    const scanContacts = () => {
      document.querySelectorAll('a[href*="wa.me"],a[href*="wa.link"]').forEach(link => {
        if (root.contains(link)) return;
        let el = link;
        while (el && el !== document.body) {
          if (getComputedStyle(el).position === 'fixed') {
            if (!el.hasAttribute('data-hamilton-floating-contact')) el.setAttribute('data-hamilton-floating-contact', '');
            break;
          }
          el = el.parentElement;
        }
      });
    };
    const scheduleVisibility = () => {
      positionGuide(); scanContacts(); cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { stickyVisibility(); fitPurchase(); if (assistance) { const hidden = modalOpen(); if (assistance.hidden !== hidden) assistance.hidden = hidden; } });
    };
    const fitObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fitPurchase) : null;
    if (card) fitObserver?.observe(card);
    cleanups.push(() => fitObserver?.disconnect());
    on(window, 'scroll', scheduleVisibility, { passive: true });
    on(window, 'resize', scheduleVisibility);
    const modalObserver = new MutationObserver(scheduleVisibility);
    modalObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['class','style','hidden','aria-hidden','open'] });
    document.body.classList.add('hamilton-pdp-active');
    const contacts = Array.from(document.querySelectorAll('a[href*="wa.me"],a[href*="wa.link"]')).filter(el => !root.contains(el));
    contacts.forEach(link => {
      let el = link;
      while (el && el !== document.body) {
        if (getComputedStyle(el).position === 'fixed') { el.setAttribute('data-hamilton-floating-contact', ''); break; }
        el = el.parentElement;
      }
    });
    const gallery = root.querySelector('.product__media');
    const thumbs = Array.from(root.querySelectorAll('[data-product-thumbnail]'));
    let carousel;
    on(gallery, 'keydown', event => {
      if (!carousel?.isActive || event.target !== gallery || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const count = gallery.querySelectorAll('.media-wrapper').length;
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 : (carousel.selectedIndex + (event.key === 'ArrowRight' ? 1 : -1) + count) % count;
      carousel.select(index);
    });
    on(document, 'flu:product:variant-change', event => {
      const current = event.detail?.variant;
      if (!current?.featured_media || !product.variants.some(v => v.id === current.id)) return;
      setTimeout(() => {
        const cells = Array.from(gallery.querySelectorAll('.media-wrapper'));
        const index = cells.findIndex(cell => String(cell.dataset.mediaId) === String(current.featured_media.id));
        if (index >= 0 && carousel?.isActive) carousel.select(index);
      }, 0);
    });
    const updateGallery = () => {
      const cells = Array.from(gallery.querySelectorAll('.media-wrapper'));
      const selected = cells.findIndex(cell => cell.classList.contains('is-selected'));
      const index = selected < 0 ? 0 : selected;
      text(root.querySelector('[data-gallery-position]'), String(index + 1));
      thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === index)); thumb.classList.toggle('active', i === index); });
      const zoom = root.querySelector('.product__media-action');
      if (zoom) zoom.hidden = cells[index]?.querySelector('.media')?.dataset.mediaType !== 'image';
    };
    const galleryObserver = new MutationObserver(updateGallery);
    galleryObserver.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    if (window.flu?.chunks?.flickity) {
      import(window.flu.chunks.flickity).then(({ Flickity }) => {
        let tries = 0;
        const findCarousel = () => {
          if (state.disposed) return;
          carousel = Flickity.data(gallery);
          if (carousel) { carousel.on('change', updateGallery); updateGallery(); }
          else if (++tries < 40) setTimeout(findCarousel, 100);
        };
        findCarousel();
      }).catch(() => {});
    }
    on(root, 'click', event => {
      const thumb = event.target.closest('[data-product-thumbnail]');
      if (!thumb || !carousel?.isActive) return;
      event.preventDefault(); event.stopImmediatePropagation(); carousel.select(thumbs.indexOf(thumb));
    }, true);
    const detailRoot = root.querySelector('[data-pdp-details]');
    const panels = detailRoot ? Array.from(detailRoot.querySelectorAll('details')) : [];
    const desktopDetails = matchMedia('(min-width:1024px)');
    let activePanel = 0;
    const tablist = detailRoot ? document.createElement('div') : null;
    const tabs = [];
    if (tablist) {
      tablist.className = 'hamilton-detail-tabs';
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'Información del modelo');
      panels.forEach((panel, index) => {
        const summary = panel.querySelector('summary');
        const content = panel.querySelector('[data-pdp-detail-panel]');
        const tab = document.createElement('button');
        tab.type = 'button'; tab.id = `${summary.id}-desktop`;
        tab.textContent = summary.textContent;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', content.id);
        tablist.append(tab); tabs.push(tab);
        on(tab, 'click', () => { activePanel = index; renderDetails(); fitPurchase(); });
        on(tab, 'keydown', event => {
          if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
          event.preventDefault();
          activePanel = event.key === 'Home' ? 0 : event.key === 'End' ? panels.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + panels.length) % panels.length;
          renderDetails(); tabs[activePanel].focus();
        });
      });
      detailRoot.prepend(tablist);
    }
    const renderDetails = () => {
      if (!detailRoot) return;
      const desktop = desktopDetails.matches;
      tablist.hidden = !desktop;
      panels.forEach((panel, index) => {
        const summary = panel.querySelector('summary');
        const content = panel.querySelector('[data-pdp-detail-panel]');
        panel.hidden = desktop && index !== activePanel;
        summary.hidden = desktop;
        if (desktop) {
          panel.open = true;
          content.setAttribute('role', 'tabpanel');
          content.setAttribute('aria-labelledby', tabs[index].id);
          content.setAttribute('tabindex', '0');
        } else {
          if (summary.hidden !== desktop) summary.hidden = desktop;
          content.removeAttribute('role'); content.removeAttribute('tabindex');
          content.setAttribute('aria-labelledby', summary.id);
          if (detailRoot.dataset.desktop === 'true') panel.open = index === activePanel;
        }
        tabs[index].setAttribute('aria-selected', String(index === activePanel));
        tabs[index].tabIndex = index === activePanel ? 0 : -1;
      });
      detailRoot.dataset.desktop = String(desktop);
    };
    on(window, 'resize', renderDetails);
    renderDetails(); positionGuide(); sync(); updateGallery(); fitPurchase();
    const dispose = () => {
      state.disposed = true;
      cleanups.forEach(cleanup => cleanup());
      syncObserver.disconnect(); modalObserver.disconnect(); galleryObserver.disconnect(); cancelAnimationFrame(frame);
      if (carousel) carousel.off('change', updateGallery);
      contacts.forEach(link => link.closest('[data-hamilton-floating-contact]')?.removeAttribute('data-hamilton-floating-contact'));
      document.body.classList.remove('hamilton-pdp-active'); instances.delete(root);
    };
    instances.set(root, dispose);
  }
  const boot = () => document.querySelectorAll('[data-hamilton-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-hamilton-pdp]').forEach(root => instances.get(root)?.()));
})();
